import React from "react";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { useSelector } from "react-redux";
import { FaTrashAlt } from "react-icons/fa";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Add_to_card_btn from "../../common-components/common_btn/Add_to_card_btn/Add_to_card_btn";

function Product_Info_Mobile_Card({
  product,
  imgSrc,
  productName,
  priceText,
  quantity = "100 ML",
  addedDate = "27-10-2026",
  onDelete,
  activeVariant,
  isVendor,
}) {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);

  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  return (
    <div className="wishlist_mobile_card">
      <button className="delete_btn" onClick={() => onDelete?.(product?.id)}>
        <FaTrashAlt />
      </button>
      <div className="mobile_top">
        <Link to={`/product-details/${encodeId(product?.id)}`}>
          <div className="product_img_box">
            <img src={imgSrc} alt={productName} />
          </div>
        </Link>
        <div className="mobile_content">
          <div className="content-wrapper">
            <Link
              to={`/product-details/${encodeId(product?.id)}`}
              className="product_name"
            >
              {productName}
            </Link>

            {/* <p className="quantity_text">Quantity</p>

            <span className="quantity_badge">{quantity}</span> */}
          </div>
        </div>{" "}
      </div>
      <div className="right-content-wrapper">
        {" "}
        <p className="date_text">{addedDate}</p>
      </div>
      <div className="mobile_btn">
        {" "}
        <p className="price_text">
          {symbol}
          {Number(priceText * rate).toFixed(2)}
        </p>
        <Add_to_card_btn
          id={product?.id}
          product={product}
          btnText="Add to Cart"
          quantity={isVendor ? activeVariant?.b2b_min_quanity : 1}
        />
      </div>
    </div>
  );
}

export default Product_Info_Mobile_Card;
